export const APP_LOADING = 'cw-app-loading';
export const APP_READY = 'cw-app-ready';
export const APP_ERROR = 'cw-app-ready';
